import { default as enUSLocale } from './en-us';
import { default as zhCNLocale } from './zh-cn';
import { default as zhTWLocale } from './zh-tw';
import { default as jaJPLocale } from './ja-jp';
import { getValue4Lang, getCurrentLang, Languages } from '~/common';

const appLocale = getValue4Lang(enUSLocale, zhCNLocale, zhTWLocale, jaJPLocale);

export default appLocale;

export const formatMessage = ({ id, values, lang = getCurrentLang() } = {}) => {
    const messages = getValue4Lang(enUSLocale.messages, zhCNLocale.messages, zhTWLocale.messages, jaJPLocale.messages, lang)
    function getMsg(_id) {
        if (!_id) {
            throw new Error('[FormattedMessage] Missing prop "id"');
        }
        if (!Object.keys(messages).includes(_id)) {
            console.warn(`[FormattedMessage] Missing messages for "${_id}"`)
        }
        return messages[_id] || _id;
    }
    let msg = getMsg(id);
    if (typeof values === 'object') {
        Object.keys(values).forEach(key => {
            let value = values[key];
            if (typeof value === 'object' && Object.keys(value).includes('id')) {
                value = getMsg(value.id);
            }
            msg = msg.replace(new RegExp(`\\{${key}\\}`, 'g'), value);
        });
    }
    return msg;
}

export const initBodyFontClass = () => {
    const lang = getCurrentLang();
    const el = document.body;
    if (lang === Languages.ja_jp) {
        el && el.classList.add('noto-sans-jp');
    } else {
        el && el.classList.remove('noto-sans-jp');
    }
}